import { sendEvents } from '@fiverr-private/futile/lib/send/sendEvents';

/**
 * Report BI Event to BigQuery
 * @param  {String}  type event type
 */
export default function reportEvent(type, data) {
    const {
        userId,
        sellerId,
        activeGigsCount
    } = data;

    const baseEventData = {
        group: 'seller_page',
        user: {
            id: userId
        },
        seller: {
            id: sellerId,
            active_gigs_count: activeGigsCount
        }
    };

    sendEvents({
        ...baseEventData,
        type
    });
}
